import { Outlet, useParams } from 'react-router';
import { useAppDispatch, useAppSelector } from '../store';
import { useEffect } from 'react';
import ApplicationError from '../Components/ErrorHandling/ApplicationError';
import { ApplicationErrorType } from '../Components/ErrorHandling/types';
import { Terminal } from '@api/Trinium/types';
import useUserTerminals from '../../Hooks/useUserTerminals';
import { setTerminal } from '../applicationSlice';

/**
 * Component to handling and maintaining the Site Code extracted from the URL.
 * Acts as a gateway to any route under /:siteCode ensuring the correct site code is
 * in the url and that the User has access to a manually entered site code.
 */
export default function TerminalProxy() {
	const { terminalNumber: urlTerminalNumber } = useParams();
	const appDispatch = useAppDispatch();
	const currentTerminal = useAppSelector((state) => state.applicationState.selectedTerminal);
	const { terminals } = useUserTerminals();

	useEffect(() => {
		if (urlTerminalNumber) {
			if (
				(!currentTerminal || urlTerminalNumber !== currentTerminal.number) && // We either do not have a current site yet, or the url site code is a different site than we were previously on
				terminals.some((item) => item.number === urlTerminalNumber)
			) {
				// The url site code is valid for this user
				const selectedTerminal = terminals.find((item) => item.number === urlTerminalNumber) as Terminal;
				appDispatch(setTerminal(selectedTerminal));
			} else if (!terminals.some((item) => item.number === urlTerminalNumber)) {
				// The Url Terminal Number is not a valid selection for the user
				appDispatch(setTerminal(null));
			}
		} else {
			// We did not get a terminal Number from the url
			appDispatch(setTerminal(null));
		}

		//Otherwise leave it, hasn't changed
	}, [urlTerminalNumber, appDispatch, terminals, currentTerminal]);

	if (terminals.length === 0) {
		return <ApplicationError type={ApplicationErrorType.NoTerminals} />;
	}

	if (urlTerminalNumber && !currentTerminal) {
		return (
			<ApplicationError
				type={ApplicationErrorType.TerminalNotFound}
				messageParam={urlTerminalNumber}
			/>
		);
	}

	return currentTerminal ? <Outlet /> : <ApplicationError type={ApplicationErrorType.NotFound} />;
}
